import { ListaToolbar } from "@/shared/components/lista-toolbar";
import { FinanceiroObrasFiltros } from "./components/financeiro-obras-filtros";
import type { FinanceiroObrasToolbarViewModel } from "./types-financeiro-obras-toolbar";

/** Barra da listagem: a barra compartilhada com os filtros rápidos de Status e Tipo. */
export function FinanceiroObrasToolbarView({
  isMobile,
  view,
  onViewChange,
  search,
  onSearchChange,
  onStatusChange,
  onTipoChange,
  isTipoDisabled,
  filterDefinitions,
  filterValue,
  onFilterChange,
  savedFilters,
  onSaveFilter,
  onDeleteSavedFilter,
  onApplySavedFilter,
  onExport,
  onOpenSettings,
  showQuickFilters,
  statusValue,
  tipoValue,
  statusOptions,
  tipoOptions,
}: FinanceiroObrasToolbarViewModel) {
  return (
    <ListaToolbar
      testIdPrefix="financeiro-obras"
      isMobile={isMobile}
      view={view}
      onViewChange={onViewChange}
      search={search}
      onSearchChange={onSearchChange}
      quickFilters={
        showQuickFilters ? (
          <FinanceiroObrasFiltros
            statusValue={statusValue}
            statusOptions={statusOptions}
            onStatusChange={onStatusChange}
            tipoValue={tipoValue}
            tipoOptions={tipoOptions}
            isTipoDisabled={isTipoDisabled}
            onTipoChange={onTipoChange}
          />
        ) : null
      }
      filterDefinitions={filterDefinitions}
      filterValue={filterValue}
      onFilterChange={onFilterChange}
      savedFilters={savedFilters}
      onSaveFilter={onSaveFilter}
      onDeleteSavedFilter={onDeleteSavedFilter}
      onApplySavedFilter={onApplySavedFilter}
      onExport={onExport}
      onOpenSettings={onOpenSettings}
    />
  );
}
